export default class TableRegion {
    constructor(startRow, startCol, endRow, endCol) {
        this.rowMin = Math.min(startRow, endRow);
        this.rowMax = Math.max(startRow, endRow);
        this.colMin = Math.min(startCol, endCol);
        this.colMax = Math.max(startCol, endCol);
    }

    createFromCells(startCell, endCell) {
        return new TableRegion(
            startCell.getRow().getRowIdx(), startCell.getColIdx(),
            endCell.getRow().getRowIdx(), endCell.getColIdx()
        );
    }

    containsCol(col) {
        return this.colMin <= col && this.colMax >= col;
    }

    containsRow(row) {
        return this.rowMin <= row && this.rowMax >= row;
    }


    contains(row, col) {
        return this.containsCol(col) && this.containsRow(row);
    }

    containsCell(cell) {
        return this.containsCol(cell.getColIdx()) && this.containsRow(cell.getRow().getRowIdx());
    }

    union(otherRegion) {
        return otherRegion == this.NULL ? this : new TableRegion(
            Math.min(this.rowMin, otherRegion.rowMin),
            Math.min(this.colMin, otherRegion.colMin),
            Math.max(this.rowMax, otherRegion.rowMax),
            Math.max(this.colMax, otherRegion.colMax)
        );
    }

    equals(region) {
        return region != this.NULL &&
               this.rowMin == region.rowMin &&
               this.colMin == region.colMin &&
               this.rowMax == region.rowMax &&
               this.colMax == region.colMax;
    }

    toString() {
        return this.rowMin + "," +
               this.colMin + "," +
               this.rowMax + "," +
               this.colMax;
    }

    isLeftmostCell(cell) {
        return this.colMin == cell.getColIdx();
    }

    isUpwardmostCell(cell) {
        return this.rowMin == cell.getRow().getRowIdx();
    }

    isRightmostCell(cell) {
        return this.colMax == cell.getColIdx();
    }

    isDownwardmostCell(cell) {
        return this.rowMax == cell.getRow().getRowIdx();
    }
}


// WEBPACK FOOTER //
// ./web/js/table/TableRegion.js